import React from "react";
import { Card, CardBody } from "reactstrap";
import { Images, TooltipWrapper } from "@workspace/common";
import { useSelector } from "react-redux";

function VendorMSACountCard({ setStatus }) {
  const preOfferCounts = useSelector(
    (state) => state.PreOfferCandidateReducer.counts
  );

  return (
    <Card className="vendor-item mb-0">
      <CardBody className="elc-cardbody">
        <div className="elc-tile-header">
          <img src={Images.icons.property_1_9} className="elc-title-icon" />
          <span className="elc-tile-title">Vendor as MSA</span>
        </div>
        <div className={"d-flex align-items-start w-100 flex-row gap-3"}>
          {/* Accepted Count */}
          <TooltipWrapper tooltipText="MSA Completed">
            <div className="d-flex flex-row align-items-center gap-2 cursor-pointer">
              <div className="approved-count-circle">
                <span className="mdi mdi-check elc-check-icon"></span>
              </div>
              <span className="approved-count">0</span>
            </div>
          </TooltipWrapper>
          {/* Pending Count */}
          <TooltipWrapper tooltipText="MSA Pending">
            <div className="d-flex flex-row align-items-center gap-2 cursor-pointer">
              <div className="pending-count-circle">
                <span className="mdi mdi-message-alert-outline elc-pending-icon"></span>
              </div>
              <span className="pending-count">0</span>
            </div>
          </TooltipWrapper>
          {/* SLA Count */}
          <TooltipWrapper tooltipText="SLA">
            <div className="d-flex flex-row align-items-center gap-2 cursor-pointer">
              <div className="sla-count-circle">
                <span className="mdi mdi-clock-alert-outline elc-alert-icon"></span>
              </div>
              <span className="sla-count">0</span>
            </div>
          </TooltipWrapper>
        </div>
      </CardBody>
    </Card>
  );
}

export default VendorMSACountCard;
